import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { usePost } from "utils/api";
import { usePagination, useQuery } from "utils/gql";
import View from "components/admin/commands/List.view";

function List() {

  const pageSize = 100;
  const formRef = useRef(null);
  const [page, setPage] = useState(1);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const reqCompanies = useQuery(`
    Company {
      result {
        id
        key
        name
      }
    }
  `, {
    order: [
      ["key", "ASC"]
    ]
  });

  const reqDevices = useQuery(`
    Device {
      result {
        id
        serial_number
        model
        description
        company {
          id
          key
          name
        }
      }
    }
  `, {
    cancel: !selectedCompany,
    order: [
      ["description", "ASC"]
    ],
    where: {
      company: {
        id: { eq: selectedCompany?.id }
      }
    }
  });

  const reqCommands = usePagination(`
    Command {
      totalPages
      result {
        id
        createdAt
        content
        response
        commit_time
        response_time
        device {
          id
        }
      }
    }
  `, page, pageSize, {
    cancel: !selectedDevice,
    order: [
      ["createdAt", "DESC"]
    ],
    where: {
      device: {
        id: { eq: selectedDevice?.id }
      }
    }
  });

  const [callExec, qExec] = usePost("/devices/execute_instructions", {
    onCompleted: () => {
      
      if (formRef.current) 
        formRef.current.resetForm();

      if (!toast.isActive("toast-exec-instructions"))
        toast.success("Instrucción enviada correctamente", { toastId: "toast-exec-instructions" })
      
    },
    onError: (err) => {
      console.error(err)
      if (!toast.isActive("toast-exec-instructions-error"))
        toast.error("Error interno del servidor", { toastId: "toast-exec-instructions-error" })
    }
  })

  const onSubmit = (values) => {
    callExec({
      instructions: {
        [values.type]: true,
        raw_command: values.raw_command,
        start_date: values.start_date,
        end_date: values.end_date,
      },
      devices: [selectedDevice.serial_number],
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const companies = reqCompanies.data?.result || [];
  const devices = reqDevices.data?.result || [];
  const commands = reqCommands.data?.result || [];
  const totalPages = reqCommands.data?.totalPages || 0;

  const isLoading = reqCommands.loading;

  return (
    <View
      formRef={formRef}
      companies={companies}
      devices={devices}
      commands={commands}
      selectedCompany={selectedCompany}
      selectedDevice={selectedDevice}
      isLoading={isLoading}
      page={page}
      totalPages={totalPages}
      setSelectedCompany={setSelectedCompany}
      setSelectedDevice={setSelectedDevice}
      setPage={setPage}
      onSubmit={onSubmit}
    />
  );

}

export default List;
